export default "__VITE_ASSET__d189aa5e__"